import axios from 'axios'
import router from '../../router'
const state = {
  adminEstateList: [],
  adminTotalCount: 0,
  adminDelRtn: ''
}

const getters = {
  getAdminEstate (state) {
    return state.adminEstateList
  },
  getAdminTotalCount (state) {
    return state.adminTotalCount
  },
  getAdminDelRtn (state) {
    return state.adminDelRtn
  }
}

const mutations = {
  setAdminEstate (state, payload) {
    state.adminEstateList = payload
  },
  setAdminTotalCount (state, payload) {
    state.adminTotalCount = payload
  },
  setAdminDelRtn (state, payload) {
    state.adminDelRtn = payload
  }
}

const actions = {
  apiAdminEstateList (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/admin/getEstateAdminList', payload)
        .then((response) => {
          // console.log(response.data)
          context.commit('setAdminEstate', response.data.itemList)
          context.commit('setAdminTotalCount', response.data.totalCount)
          if (response.data.itemList.length <= 0) {
            alert('검색 값이 존재하지 않습니다.')
          }
        })
        .catch((error) => {
          if (error.response.status === 403) {
            sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.replace('/AdminLogin')
          }
        })
    }
  },
  apiAdminDeleteEstate (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      return new Promise((resolve, reject) => {
        axios.post('/api/admin/deleteEstateData', payload)
          .then((response) => {
            // console.log('deleteTran = ' + response.data)
            context.commit('setAdminDelRtn', response.data)
            resolve()
          })
          .catch((error) => {
            reject(error.response.data.message)
            if (error.response.status === 403) {
              sessionStorage.removeItem('token')
              alert('세션 만료 또는 잘못된 접근 입니다.')
              router.replace('/AdminLogin')
            } else {
              alert('삭제가 정상적으로 처리되지 않았습니다.')
            }
            // alert(error.response.data.message)
          })
      })
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/adminestate.js